"use client";
import { Button } from "@kyan/ui";

import { ConnectWalletWrapper } from "#/components/ConnectWalletWrapper/ConnectWalletWrapper";
import { confirmTrade } from "#/utils/modals/confirmTrade";

import { Hedge } from "../../../OptionsTab/components/SelectedOption/components/Hedge/Hedge";
import { PortfolioImpactAndGreeks } from "../../../OptionsTab/components/SelectedOption/components/PortfolioImpactAndGreeks/PortfolioImpactAndGreeks";
import { PortfolioImpact } from "../../../PerpsTab/components/PortfolioImpact/PortfolioImpact";
import { TradeConfirmationOptionInstrument } from "../TradeConfirmationOptionInstrument/TradeConfirmationOptionInstrument";
import { TradeConfirmationPerpInstrument } from "../TradeConfirmationPerpInstrument/TradeConfirmationPerpInstrument";
import { TradeConfirmModalButton } from "../TradeConfirmModalButton/TradeConfirmModalButton";
import { useMarketTradeButtonController } from "./MarketTradeButton.controller";

export interface MarketTradeButtonProps {
  isTradeConfirmation?: boolean;
  onSuccess?: () => void;
}

export const MarketTradeButton: React.FC<MarketTradeButtonProps> = ({
  isTradeConfirmation = false,
  onSuccess,
}) => {
  const {
    isPerps,
    isLoading,
    isDisabled,
    buttonLabel,
    isSecondaryButtonVisible,
    secondaryButtonLabel,
    showTradeConfirmation,
    handleSecondaryButtonClick,
    handleTrade,
  } = useMarketTradeButtonController(onSuccess);

  // if we move this logic into the controller, since we are using MarketTradeButton we will face circular dependency issues
  const handleClick = () => {
    if (showTradeConfirmation && !isTradeConfirmation) {
      confirmTrade({
        header: "Market-Limit Order",
        children: (
          <div className="grid gap-4">
            {isPerps ? (
              <>
                <TradeConfirmationPerpInstrument />
                <PortfolioImpact />
              </>
            ) : (
              <>
                <TradeConfirmationOptionInstrument />
                <Hedge />
                <PortfolioImpactAndGreeks isTradeConfirmation />
              </>
            )}
          </div>
        ),

        tradeButton: ({ handleClose }) => (
          <TradeConfirmModalButton
            isTradeConfirmation
            onSuccess={handleClose}
          />
        ),
      });
      return;
    }

    handleTrade();
  };

  return (
    <ConnectWalletWrapper>
      <Button
        size="lg"
        disabled={isDisabled}
        isLoading={isLoading}
        className="mt-2 w-full text-[15px] shadow-none"
        onClick={handleClick}
      >
        {buttonLabel}
      </Button>
      {isSecondaryButtonVisible && (
        <Button
          variant="link"
          className="mt-3 w-full"
          onClick={handleSecondaryButtonClick}
        >
          {secondaryButtonLabel}
        </Button>
      )}
    </ConnectWalletWrapper>
  );
};
